__webpack_require__.p = "https://t-patroller-staging.app.talabat.wearyourebrand.com/";